import funcion from './funcion/diashabiles'

const funciones = {
  funcion: funcion
}

export default funciones;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/diashabiles/diashabilesapi.js
// module id = null
// module chunks = 